import {Component} from "react";

export class SellToWebTableColumnComponent extends Component {
}
